import styled from 'styled-components';
import { Clickable, Grid } from '../performance-operations/styles';

// PM Analitik Faz 2 (spec §8, §9) — çalışma alanı sayfalarının (E18 Performansım, E17 Ekibimin Performansı) ortak kabuğu.
// TEK KAYDIRMA: kabuk sayfa yüksekliğini doldurur ve kendisi kaymaz; başlık (yol, süzgeç, sekmeler) sabit, yalnız sekme gövdesi
// kayar. DataTable'lı sekmede gövde kaymaz ($scroll=false), yalnız tablo satırları kayar (ölçülen yükseklik deseni,
// SurveyDetailPage emsali). Gömülü sayfalar (Hedeflerim, Görüşmelerim) DataTable iç kaydırması kapalı çizilir ('none').
export const PageShell = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

export const ShellHeader = styled.div`
  flex-shrink: 0;
  min-width: 0;
`;

// Dar ekranda beş sekme sığmazsa şerit yatay kayar (sayfa yatay kaymaz).
export const TabStrip = styled.div`
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const TabBody = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: ${({ $scroll = true }) => ($scroll ? 'auto' : 'hidden')};
`;

// Özet ızgarası: 768 px altında birincil görev en üstte, kartlar tek kolon (kart genişliği operasyon panosu ızgarasından).
export const SummaryGrid = styled(Grid)`
  @media (max-width: 768px) {
    [data-panel='primaryTask'] {
      order: -1;
    }
  }
`;

export const TopBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 16px;
`;

export const Field = styled.div`
  width: ${({ $w }) => $w || '240px'};
  max-width: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const NextDue = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.muted};

  strong {
    color: ${({ theme, $overdue }) => ($overdue ? theme.colors.auxiliar.danger : theme.colors.text.primary)};
    font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  }
`;

export const ListRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 0;
  min-width: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.surface.border};

  &:last-child {
    border-bottom: none;
  }
`;

export const RowButton = styled(Clickable)`
  display: block;
  flex: 1;
  min-width: 0;
`;

export const RowMain = styled.div`
  flex: 1;
  min-width: 0;
`;

export const RowTitle = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RowHead = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
`;

export const MetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
`;

export const ProgressLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
`;

export const SectionLabel = styled.div`
  margin: 14px 0 4px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const Warn = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  color: ${({ theme }) => theme.colors.auxiliar.warning};
`;

export const Highlight = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  margin-bottom: 8px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.bgColor};
  border-left: 3px solid ${({ theme, $overdue }) => ($overdue ? theme.colors.auxiliar.danger : theme.colors.primary.main)};
`;

export const HighlightTitle = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.md};
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const InfoLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const ScoreRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 10px;
`;

export const ScoreValue = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xl};
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Explain = styled.p`
  margin: 0 0 12px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
  line-height: 1.5;
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
`;
